<template>
    <div class="front_container">
        <div class="card_row" >
            <div v-for="consultancy in getConsultancies" :key="consultancy.id" class="card">
                <span v-if="consultancy.logo" > <img :src="consultancy.logo" alt="Logo" class="width_img" ></span>
                <span v-else> <img src="@/assets/LOGO.png" alt="Logo" class="width_img" ></span>
                <!-- <img :src="consultancy.logo" alt="John" class="width_img" > -->
                <h5>{{ consultancy.client_name }}</h5>
                <button class="cmst_btn" @click="$router.push(`/profile/${consultancy.id}`)">View Details</button>
            </div> 
        </div>
        <div class="search_error" v-if="search && getConsultancies.length === 0">
            <span>Sorry ! The consultancy you are searching is not found. Please search correctly.</span>   
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    computed: {
        ...mapGetters(['consultancies', 'search']),
        getConsultancies(){
            if(this.search.length < 2){
                return this.consultancies
            }
           return this.consultancies.filter(consultancy => {
                return consultancy.client_name.toLowerCase().match(this.search.toLowerCase())
            });
        }
    },
    // created() {
    //     this.$store.commit('SET_CONSULTANCIES',this.consultancies);
    // }
    mounted(){
    document.title = 'Consultancy Finder';
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard.vue